import {useMemo} from 'react'

import type {MomentRange} from '../../../types'
import {getProducedPerMaterial} from '../../../utils/assetCapacity.helpers'
import {useAssetsCapacity} from '../useAssetsCapacity'

export const useProducedPerMaterial = (timeFrame: MomentRange) => {
  const {data: assetsCapacityById, ...queryResult} = useAssetsCapacity(timeFrame)

  const data = useMemo(
    () => (assetsCapacityById ? getProducedPerMaterial(assetsCapacityById) : undefined),
    [assetsCapacityById]
  )

  return {data, ...queryResult}
}
